export const BOTTOM_NAV_HEIGHT = '44px'
export const BOTTOM_CONSOLE_HEIGHT = '10vh'

export const DRAWER_WIDTH = 300
